/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
import { __spreadArray, __assign } from '../../_virtual/_tslib.js';
import React__default from 'react';
import RunConfig from '../../utils/RunConfig/runconfig.js';

var AuthContext = React__default.createContext({
    userName: localStorage.getItem('UserName'),
    accessToken: localStorage.getItem('AccessToken'),
    accessTokenExp: localStorage.getItem('AccessTokenExp'),
    refreshToken: localStorage.getItem('RefreshToken'),
    refreshTokenExp: localStorage.getItem('RefreshTokenExp'),
    azp: localStorage.getItem('Azp'),
    roles: JSON.parse(localStorage.getItem('Roles') || '[]'),
    isLoggedIn: function () { return false; },
    isAccessTokenExpired: function () { return false; },
    readRoles: function () { return []; },
    hasRole: function (role) { return false; },
    update: function (userName, accessToken, accessTokenExp, refreshToken, refreshTokenExp, azp, roles) { return null; },
    clear: function () { return null; }
});
var AuthContextProvider = function (_a) {
    var children = _a.children;
    var clientId = RunConfig === null || RunConfig === void 0 ? void 0 : RunConfig.clientId;
    var removeFromLocalstorage = React__default.useCallback(function () {
        localStorage.removeItem('UserName');
        localStorage.removeItem('AccessToken');
        localStorage.removeItem('AccessTokenExp');
        localStorage.removeItem('RefreshToken');
        localStorage.removeItem('RefreshTokenExp');
        localStorage.removeItem('Azp');
        localStorage.removeItem('Roles');
    }, []);
    var isLoggedInHandler = React__default.useCallback(function () {
        return Date.now() / 1000 <= +(localStorage.getItem('RefreshTokenExp') || '0');
    }, []);
    var isAccessTokenExpiredHandler = React__default.useCallback(function () {
        return Date.now() / 1000 > +(localStorage.getItem('AccessTokenExp') || '0');
    }, []);
    var readRolesHandler = React__default.useCallback(function () {
        var _a, _b, _c;
        var rolesObj = JSON.parse(localStorage.getItem('Roles') || '[]');
        var realmRoles = ((_a = rolesObj === null || rolesObj === void 0 ? void 0 : rolesObj.realm_access) === null || _a === void 0 ? void 0 : _a.roles) || [];
        var resourceRoles = ((_c = (_b = rolesObj === null || rolesObj === void 0 ? void 0 : rolesObj.resource_access) === null || _b === void 0 ? void 0 : _b[clientId]) === null || _c === void 0 ? void 0 : _c.roles) || [];
        return __spreadArray(__spreadArray([], realmRoles, true), resourceRoles, true);
    }, [clientId]);
    var hasRoleHandler = React__default.useCallback(function (role) {
        var _a, _b, _c, _d;
        var rolesObj = JSON.parse(localStorage.getItem('Roles') || '[]');
        if (!rolesObj)
            return false;
        var isSuperAdmin = (_b = (_a = rolesObj.realm_access) === null || _a === void 0 ? void 0 : _a.roles) === null || _b === void 0 ? void 0 : _b.includes('super_admin');
        var hasRole = rolesObj.resource_access ? (_d = (_c = rolesObj.resource_access[clientId]) === null || _c === void 0 ? void 0 : _c.roles) === null || _d === void 0 ? void 0 : _d.includes(role) : false;
        return isSuperAdmin || hasRole;
    }, [clientId]);
    var clearHandler = React__default.useCallback(function () {
        removeFromLocalstorage();
        setContextValue(function (prevState) {
            var stateValue = __assign({}, prevState);
            stateValue.userName = '';
            stateValue.accessToken = '';
            stateValue.accessTokenExp = '';
            stateValue.refreshToken = '';
            stateValue.refreshTokenExp = '';
            stateValue.azp = '';
            stateValue.roles = null;
            return stateValue;
        });
    }, [removeFromLocalstorage]);
    var updateHandler = React__default.useCallback(function (userName, accessToken, accessTokenExp, refreshToken, refreshTokenExp, azp, roles) {
        localStorage.setItem('UserName', userName);
        localStorage.setItem('AccessToken', accessToken);
        localStorage.setItem('AccessTokenExp', accessTokenExp);
        localStorage.setItem('RefreshToken', refreshToken);
        localStorage.setItem('RefreshTokenExp', refreshTokenExp);
        localStorage.setItem('Azp', azp);
        localStorage.setItem('Roles', JSON.stringify(roles));
        setContextValue(function (prevState) {
            var stateValue = __assign({}, prevState);
            stateValue.userName = userName;
            stateValue.accessToken = accessToken;
            stateValue.accessTokenExp = accessTokenExp;
            stateValue.refreshToken = refreshToken;
            stateValue.refreshTokenExp = refreshTokenExp;
            stateValue.azp = azp;
            stateValue.roles = roles;
            return stateValue;
        });
    }, []);
    var _b = React__default.useState({
        userName: localStorage.getItem('UserName'),
        accessToken: localStorage.getItem('AccessToken'),
        accessTokenExp: localStorage.getItem('AccessTokenExp'),
        refreshToken: localStorage.getItem('RefreshToken'),
        refreshTokenExp: localStorage.getItem('RefreshTokenExp'),
        azp: localStorage.getItem('azp'),
        roles: JSON.parse(localStorage.getItem('Roles') || '[]'),
        isLoggedIn: isLoggedInHandler,
        isAccessTokenExpired: isAccessTokenExpiredHandler,
        readRoles: readRolesHandler,
        hasRole: hasRoleHandler,
        update: updateHandler,
        clear: clearHandler
    }), contextValue = _b[0], setContextValue = _b[1];
    return (React__default.createElement(AuthContext.Provider, { value: contextValue }, children));
};
var AuthContext$1 = AuthContext;

export { AuthContextProvider, AuthContext$1 as default };
